import React from 'react';
const tomes = [{
  label: 'Tomo 1',
  color: 'rgb(21, 101, 192)',
  emoji: '✏️',
  desc: 'Primeras Letras'
}, {
  label: 'Tomo 2',
  color: 'rgb(46, 125, 50)',
  emoji: '🔢',
  desc: 'Mundo Numérico'
}, {
  label: 'Tomo 3',
  color: 'rgb(230, 81, 0)',
  emoji: '✂️',
  desc: 'Manitos Creativas'
}, {
  label: 'Tomo 4',
  color: 'rgb(106, 27, 154)',
  emoji: '❤️',
  desc: 'Mis Emociones'
}, {
  label: 'Tomo 5',
  color: 'rgb(55, 71, 79)',
  emoji: '🏠',
  desc: 'Rutinas del Hogar'
}, {
  label: 'Tomo 6',
  color: 'rgb(191, 54, 12)',
  emoji: '🌍',
  desc: 'Inglés Divertido'
}];
const features = ['✅ +500 páginas listas para imprimir', '✅ Letras, números, lógica e inglés inicial', '✅ Actividades por nivel de dificultad', '✅ Diseñado para niños de 2 a 7 años', '✅ Sin pantallas, sin berrinches', '✅ Descargá hoy, imprimí hoy'];
export function ProductShowcase() {
  return <section className="w-full bg-white px-4 py-10 text-gray-900 text-base leading-6" style={{
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-265">
      <div className="mx-auto max-w-4xl text-center" data-id="element-266">
        {/* BADGE */}
        <div className="mb-6 inline-flex items-center gap-2 text-xs font-bold tracking-wide text-orange-500 border border-orange-400/50 bg-orange-50 rounded-full px-4 py-1.5" data-id="element-267">
          🏆 El refuerzo escolar más completo de Argentina
        </div>

        {/* MARCA */}
        <h2 className="text-4xl leading-[40px] font-black text-gray-900 m-0 mb-2" data-id="element-268">
          🧒 CONSTRUYE PROGRESO™
        </h2>

        {/* NOMBRE DEL PRODUCTO */}
        <h3 className="text-xl font-bold text-orange-500 m-0 mb-4" data-id="element-269">
          MEGAPACK ANTI PANTALLA
        </h3>

        {/* DESCRIPCIÓN */}
        <p className="mx-auto max-w-2xl text-base leading-[24px] text-gray-800 m-0 mb-8" data-id="element-270">
          <strong data-id="element-271">
            6 Tomos + 6 Bonos — 2 a 7 años — Todo listo para imprimir.
          </strong>
          <br data-id="element-272" />
          +500 páginas · Lectoescritura · Números · Lógica · Inglés Inicial ·
          Emociones · Rutinas · Tijera y Motricidad · Actividades por nivel ·
          Sin pantallas · Sin improvisación. Descargalo hoy y usalo mañana.
        </p>

        {/* TOMOS GRID */}
        <div className="relative mx-auto max-w-3xl mb-8" data-id="element-273">
          <div className="grid grid-cols-6 justify-center gap-2" data-id="element-274">
            {tomes.map(tome => <div key={tome.label} className="flex flex-col items-center justify-between aspect-[3/4] shadow-md border-2 border-orange-400 rounded-lg overflow-hidden" style={{
            backgroundColor: tome.color
          }} data-id="element-275">
                <div className="flex-1 flex items-center justify-center" data-id="element-276">
                  <span className="text-3xl sm:text-4xl drop-shadow-lg" data-id="element-277">
                    {tome.emoji}
                  </span>
                </div>
                <div className="w-full bg-black/30 backdrop-blur-sm py-1.5 px-1 text-center" data-id="element-278">
                  <span className="block text-[10px] font-bold text-white" style={{
                textShadow: 'rgba(0, 0, 0, 0.8) 0px 1px 3px'
              }} data-id="element-279">
                    {tome.label}
                  </span>
                  <span className="block text-[8px] sm:text-[9px] text-white/80 leading-tight mt-0.5" data-id="element-280">
                    {tome.desc}
                  </span>
                </div>
              </div>)}
          </div>

          {/* BADGE DEBAJO DE LOS TOMOS */}
          <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 whitespace-nowrap bg-orange-500 text-[10px] font-black text-white rounded-full px-3 py-1 shadow-sm" data-id="element-281">
            6 TOMOS COMPLETOS — 2 A 7 AÑOS
          </div>
        </div>

        {/* FEATURES */}
        <div className="mt-8 mx-auto max-w-2xl grid grid-cols-2 sm:grid-cols-3 gap-1.5" data-id="element-282">
          {features.map(feature => <span key={feature} className="bg-orange-50 border border-orange-200 rounded-full px-3 py-1 text-[11px] sm:text-xs font-semibold text-gray-700 text-center" data-id="element-283">
              {feature}
            </span>)}
        </div>

        {/* CTA */}
        <div className="mt-8" data-id="element-284">
          <p className="text-xs text-gray-400 mt-2" data-id="element-285">
            🛡️ Garantía 7 días · ⚡ Acceso inmediato · 🔒 Pago seguro
          </p>
        </div>
      </div>
    </section>;
}